import React, { useCallback, useRef, useState } from "react";

export const useOtpState = (length: number = 6) => {
  const [otp, setOtp] = useState<string[]>(new Array(length).fill(""));
  const inputRefs = useRef<Array<HTMLInputElement | null>>([]);

  const resetOtp = useCallback(() => {
    setOtp(new Array(length).fill(""));
    setTimeout(() => {
      inputRefs.current[0]?.focus();
    }, 0);
  }, [length]);

  const handleChange = useCallback(
    (index: number, value: string) => {
      if (!/^\d*$/.test(value)) return;

      const newOtp = [...otp];
      newOtp[index] = value.substring(value.length - 1);
      setOtp(newOtp);

      if (value && index < length - 1) {
        setTimeout(() => {
          inputRefs.current[index + 1]?.focus();
        }, 0);
      }
    },
    [otp, length]
  );

  const handleKeyDown = useCallback(
    (index: number, e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === "Backspace" && !otp[index] && index > 0) {
        inputRefs.current[index - 1]?.focus();
      }
    },
    [otp]
  );

  const handlePaste = useCallback(
    (e: React.ClipboardEvent) => {
      e.preventDefault();
      const pastedData = e.clipboardData.getData("text").trim().slice(0, length).split("");
      if (pastedData.every((char) => /^\d$/.test(char))) {
        const newOtp = [...otp];
        pastedData.forEach((char, index) => {
          newOtp[index] = char;
        });
        setOtp(newOtp);
        const nextIndex = pastedData.length < length ? pastedData.length : length - 1;
        setTimeout(() => {
          inputRefs.current[nextIndex]?.focus();
        }, 0);
      }
    },
    [otp, length]
  );

  return {
    otp,
    setOtp,
    inputRefs,
    resetOtp,
    handleChange,
    handleKeyDown,
    handlePaste,
    otpValue: otp.join(""),
    isComplete: otp.every((digit) => digit !== ""),
  };
};
